'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import type { Fragment } from 'react';
import { cn } from '../../../shared/cn';
export function Listbox(t0) {
  const $ = _c(32);
  let ariaLabel;
  let autoFocus;
  let className;
  let options;
  let placeholder;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      placeholder,
      autoFocus,
      "aria-label": ariaLabel,
      anchor: t1,
      children: options,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = autoFocus;
    $[3] = className;
    $[4] = options;
    $[5] = placeholder;
    $[6] = props;
    $[7] = t1;
  } else {
    ariaLabel = $[1];
    autoFocus = $[2];
    className = $[3];
    options = $[4];
    placeholder = $[5];
    props = $[6];
    t1 = $[7];
  }
  const anchor = t1 === undefined ? "selection start" : t1;
  let t2;
  if ($[8] !== className) {
    t2 = cn(["group relative block w-full", "before:absolute before:inset-px before:rounded-[calc(var(--radius-lg)-1px)] before:bg-white before:shadow-xs", "dark:before:hidden", "focus:outline-hidden", "after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset data-focus:after:ring-2 data-focus:after:ring-blue-500", "data-disabled:opacity-50", className]);
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== placeholder) {
    t3 = placeholder && <span className="block truncate text-zinc-500">{placeholder}</span>;
    $[10] = placeholder;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(["relative block w-full rounded-lg py-[calc(--spacing(2.5)-1px)] sm:py-[calc(--spacing(1.5)-1px)]", "min-h-11 sm:min-h-9", "pr-[calc(--spacing(7)-1px)] pl-[calc(--spacing(3.5)-1px)] sm:pl-[calc(--spacing(3)-1px)]", "text-left text-base/6 text-contentPrimary placeholder:text-contentTertiary sm:text-sm/6 forced-colors:text-[CanvasText]", "border border-borderPrimary group-data-active:ring-2 group-data-active:ring-blue-500", "bg-backgroundPrimary group-data-hover:bg-backgroundHoverOverlay", "group-data-hover:group-data-invalid:border-red-500 group-data-invalid:border-red-500 dark:group-data-invalid:border-red-600", "group-data-disabled:border-zinc-950/20 dark:group-data-disabled:border-white/15 dark:group-data-disabled:bg-white/[2.5%]"]);
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== options || $[14] !== t3) {
    t5 = <Headless.ListboxSelectedOption as="span" options={options} placeholder={t3} className={t4} />;
    $[13] = options;
    $[14] = t3;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"><svg className="size-5 stroke-contentSecondary sm:size-4 forced-colors:stroke-[CanvasText]" viewBox="0 0 16 16" aria-hidden="true" fill="none"><path d="M5.75 10.75L8 13L10.25 10.75" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path d="M10.25 5.25L8 3L5.75 5.25" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg></span>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== ariaLabel || $[18] !== autoFocus || $[19] !== t2 || $[20] !== t5) {
    t7 = <Headless.ListboxButton autoFocus={autoFocus} data-slot="control" aria-label={ariaLabel} className={t2}>{t5}{t6}</Headless.ListboxButton>;
    $[17] = ariaLabel;
    $[18] = autoFocus;
    $[19] = t2;
    $[20] = t5;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const t8 = anchor === "bottom start" ? "[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(4)]" : "[--anchor-offset:-1.625rem] [--anchor-padding:--spacing(4)] sm:[--anchor-offset:-1.375rem]";
  let t9;
  if ($[22] !== t8) {
    t9 = cn(t8, "isolate z-50 w-max min-w-[calc(var(--button-width))] select-none scroll-py-1 rounded-xl p-1", "outline outline-transparent", "overflow-y-scroll overscroll-contain", "bg-backgroundPrimary", "shadow-lg ring-1 ring-zinc-950/10 dark:ring-white/10 dark:ring-inset", "transition-opacity duration-100 ease-in data-closed:data-leave:opacity-0 data-transition:pointer-events-none");
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== anchor || $[25] !== options || $[26] !== t9) {
    t10 = <Headless.ListboxOptions transition={true} anchor={anchor} className={t9}>{options}</Headless.ListboxOptions>;
    $[24] = anchor;
    $[25] = options;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== props || $[29] !== t10 || $[30] !== t7) {
    t11 = <Headless.Listbox {...props} multiple={false}>{t7}{t10}</Headless.Listbox>;
    $[28] = props;
    $[29] = t10;
    $[30] = t7;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}